/* eslint-disable global-require */
import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap-float-label.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css';
import './assets/font/simple-line-icons/css/simple-line-icons.css';
import './assets/font/iconsmind-s/css/iconsminds.css';
import './assets/css/dore.light.greenlime.css';
import './assets/css/style.css';
// import './assets/css/main.css';

const theme = 'light.greenlime';

const render = () => {
  import(`./assets/css/dore.${theme}.css`).then(() => {
    require('./AppRenderer');
  });
};
render();
